const options = [
  "General",
  "Feedback",
  "Payments",
  "Technical",
  "Account",
  "Other"
];

const CUSTOMER_SERVICE_OPTIONS = [
  {
    type: "call",
    content: "+1 (866) 432-7695"
  },
  {
    type: "email",
    content: "help@tomocredit.com"
  },
  {
    type: "hours of operation",
    content: "Mon-Fri (8am-8pm EST)"
  }
];

export { CUSTOMER_SERVICE_OPTIONS, options };
